import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiUnsubscribeComponent } from "./new-ui-unsubscribe.component";

@Component({
  selector: "app-unsubscribe",
  templateUrl: "./unsubscribe.component.html",
  styleUrl: "./unsubscribe.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, RouterLink, Button, NgIf],
})
export class UnsubscribeComponent extends NewUiUnsubscribeComponent {}
